import React from 'react';
import { useParams } from 'react-router-dom';
import ErrorMessage from '../../components/ErrorMessage';
import LoadingState from '../../components/LoadingState';
import { NoOrgView } from './components/NoOrgView';
import { SelectOrgForTraining } from './components/SelectOrgForTraining';
import { VerifyOrg } from './components/VerifyOrg';
import { useRequireOrgForTraining } from './hooks/useRequireOrgForTraining';
import { TrainingExists } from './components/TrainingExists';

export function RequireOrgForTraining() {
  const { trainingId } = useParams<{ trainingId: string }>();
  const { state, onChangeChurch, onCreateChurchAccount, onOrgSelected, onSelectOrgBack } =
    useRequireOrgForTraining(trainingId);

  switch (state.status) {
    case 'loading':
      return <LoadingState />;

    case 'error':
      return <ErrorMessage>{state.message}</ErrorMessage>;

    case 'noOrg':
      return (
        <NoOrgView
          trainingName={state.training.name}
          trainingPosterImage={state.training.posterImage}
          onContinueSetup={onCreateChurchAccount}
        />
      );

    case 'verifyOrg':
      return (
        <VerifyOrg
          trainingId={state.training.id}
          trainingName={state.training.name}
          trainingPosterImage={state.training.posterImage}
          orgName={state.currentOrg.name}
          orgLogo={state.currentOrg.logo}
          orgChurchAccountId={state.currentOrg.churchAccountId}
          isOrgRestricted={state.isRestricted}
          onChangeChurch={onChangeChurch}
        />
      );

    case 'selectOrg':
      return (
        <SelectOrgForTraining
          allowableOrgs={state.allowableOrgs}
          currentOrgId={state.currentOrg.id}
          onOrgSelected={onOrgSelected}
          onCreateChurchAccount={onCreateChurchAccount}
          onBack={onSelectOrgBack}
        />
      );

    case 'trainingExists':
      return (
        <TrainingExists
          trainingId={state.training.id}
          trainingName={state.training.name}
          trainingPosterImage={state.training.posterImage}
          trainingInstance={state.trainingInstance}
        />
      );

    default:
      return <LoadingState />;
  }
}
